<template>
	<section id="main-wrapper">
		<div class="sy-ch-main container-fluid">
			<h1 class = "mb2">Categories</h1>
			<!--===================== ADDING =====================-->
			<div v-if = "adding" >
				<div class = "mb1">
					<button class = "btn btn-md btn-gradient-danger mr-2"  @click = "cancel">Cancel</button>
					<button class = "btn btn-md btn-gradient-success"  @click = "addSubmit">Create</button>
				</div>
				<table class = "table table-bordered">
					<tbody>
						<tr>
							<th>
								Name
							</th>
							<td>
								<input type = "text" class = "form_control" placeholder = "Name" v-model = "addForm['Name']">
								<p class = "font-red">{{errorMsg["Name"]}}</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!--===================== EDITING =====================-->
			<div v-else-if = "editing" >
				<div class = "mb1">
					<button class = "btn btn-md btn-gradient-danger mr-2"  @click = "cancel">Cancel</button>
					<button class = "btn btn-md btn-gradient-success"  @click = "editSubmit">Update</button>
				</div>
				<table class = "table table-bordered">
					<tbody>
						<tr>
							<th>
								Name
							</th>
							<td>
								<input type = "text" class = "form_control" placeholder = "Name" v-model = "editForm['Name']">
								<p class = "font-red">{{errorMsg["Name"]}}</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!--===================== VIEWING =====================-->
			<div v-else-if = "viewing" >
				<div class = "mb1">
					<button class = "btn btn-md btn-gradient-danger mr-2"  @click = "cancel">Cancel</button>
				</div>
				<table class = "table table-bordered">
					<tbody>
						<tr>
							<th>
								Name
							</th>
							<td>
								{{viewForm['Name']}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--===================== SORT =====================-->
			<div v-else-if = "sorting" >
				<div class = "mb1">
					<button class = "btn btn-md btn-gradient-danger mr-2"  @click = "cancel">Cancel</button>
					<button class = "btn btn-md btn-gradient-success"  @click = "sortEnd">Update</button>
				</div>

				<ul id = "PreorderCategoriesList">
					<li v-for = "(ID, index) in indices" v-bind:id = "ID" class="sorting-items">
						<img v-bind:src="items[ID].Photo" alt="" style = "width: auto; height: 300px;" v-if = "items[ID].Photo != undefined && items[ID].Photo != ''">
						{{items[ID]["Name"]}}
					</li>
				</ul>
			</div>
			<!--===================== ALL =====================-->
			<div v-else >
				<div class = "mb1">
					<button class = "btn btn-md btn-gradient-info mr-2"  @click = "sortStart">Sort</button>
					<button class = "btn btn-md btn-gradient-primary"  @click = "addStart">Add</button>
					<input type = "text" class = "form_control mt1 mb1" placeholder = "Search" v-model = "filterText" >
				</div>
				<table class = "table "style = "width: 100%;">
					<thead>
						<!-- <th>Photo</th> -->
						<th>Name</th>
						<th>
							Actions
						</th>
					</thead>
					<tbody>
						<tr v-for = "(ID, index) in indices" v-if = "filterItem(items[ID], filterText)" >
							<td>
								{{items[ID]["Name"]}}
							</td>
							<td>
								<button class = "btn btn-sm btn-gradient-info"  @click = "editStart(items[ID], ID, index)">Edit</button>
								<button class = "btn btn-sm btn-gradient-danger"  @click = "deleteItem(items[ID], ID, index)">Delete</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</section>
</template>


<script>
import imageCompression from 'browser-image-compression';
import XLSX from "xlsx";
var md5 = require('md5');
var uuid = require('uuid/v5');
var dbPath = "settings";
var docID = "preorderSetting";
var itemTemplate;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"Name","checkFun":"text","children":[],"defaultValue":"","inputType":"text","manyView":true,"max":"","min":"","placeholder":"Name","singleView":true,"type":"Name"}];
		return{
			// FORM
			addForm: {},
			editForm: {},
			viewForm: {},
			errorMsg: {},

			// NAV VARIABLES
			adding: false,
			editing: false,
			viewing: false,
			sorting: false,
			filterText: "",

			// PLACEHOLDER
			items: [],
			oriItem: this.$parent.preOrderSetting,
			indices: [],
			editIndex: "",

			excelError: "",
			oldCat: ""

		}
	},

	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/settings";
		docID = "preOrderSetting";
		this.items = myCopier.copy(this.oriItem["PreorderCategories"]);
		this.indices = myCopier.copy(this.oriItem["PreorderCategoriesIndices"]);
	},

	watch:{
		"$parent.preOrderSetting"(){
			this.oriItem = this.$parent.preOrderSetting;
			this.items = myCopier.copy(this.oriItem["PreorderCategories"]);
			this.indices = myCopier.copy(this.oriItem["PreorderCategoriesIndices"]);
		},
	},
	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		//------------------------------ SORT -------------------------------//
		sortStart(){
			this.sorting = true;
			setTimeout(()=>{
				var sortable = $("#PreorderCategoriesList").sortable({
					delay: 50,
					disable: false
				});
				sortable.sortable("enable");
			}, 300);
		},
		sortEnd(){
			var arr = $( "#PreorderCategoriesList").sortable("toArray");
			var sortable = $("#PreorderCategoriesList").sortable("cancel");
			sortable.sortable("disable");
			var update = {};
			update["PreorderCategoriesIndices"] = arr;
			myFB.updateDoc(dbPath, update, docID, this);				
			this.sorting = false;
		},
		sortCancel(){
			var sortable = $("#PreorderCategoriesList").sortable("cancel");
			sortable.sortable("disable");
			this.sorting = false;
		},
		//------------------------------ PHOTO -------------------------------//
		async setPhoto(e, item, ID){
			let fileList = e.target.files || e.dataTransfer.file;

			if (item.Photo != undefined && item.Photo != ''){
				myFB.storage.ref(dbPath + "/preorder/" + ID).delete();
			}

			const options = { 
				maxSizeMB: 0.1,          
				maxWidthOrHeight: 300,   
			}
			const compressedFile = await imageCompression(fileList[0], options);
			console.log('compressedFile instanceof Blob', compressedFile instanceof Blob);
			console.log(`compressedFile size ${compressedFile.size / 1024 } KB`);
			var update = {};
			update["PreorderCategories." + ID + ".Photo"] =  await this.uploadFile(compressedFile,dbPath + "/preorder/" + ID)

			myFB.updateDoc(dbPath, update, docID, this, "Updating photo...", "Photo updated!");        
		},
		async uploadFile(f, path){
			var fileURL = "";

			console.log("Uploading to " + path);
			await myFB.storage.ref(path).put(f).then(async r=>{
				await r.ref.getDownloadURL().then(async url=>{
					fileURL = url;
				})
			});
			return fileURL;
		},
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDate(input, mode);
		},
		formatDateTime(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDateTime(input, mode, {sequence: "hh:mm"});
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//-------------------------------- FILTERS --------------------------------//
		filterItem(item, text){
			var filter = text.toUpperCase();
			var name = (item["Name"]).toString().toUpperCase().includes(filter);
			return name;
		},
		//-------------------------------- CREATE -------------------------------//
		addStart(){
			var response = myInput.init(itemTemplate);
			this.errorMsg = response.errorMsg;
			this.addForm = response.output;
			this.adding = true;
		},
		addSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, addForm = myCopier.copy(this.addForm);
			response = myInput.checkMain(addForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){

				var ID = uuid(Date() + Math.random(), uuid.DNS);
				var update = {};
				update["PreorderCategories." + ID] = response.output;
				update["PreorderCategoriesIndices"] = myFB.fieldVal.arrayUnion(ID);
				myFB.updateDoc(dbPath, update, docID, this, "Creating PreorderCategories...", "PreorderCategories created!");
				this.cancel();
			}
		},
		//------------------------------ UPDATE ------------------------------//
		editStart(item, ID, docIndex){
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.errorMsg = response.errorMsg;
			this.editForm = response.output;
			this.editIndex = ID;
			this.editing = true;
			this.oldCat = item.Name;
		},
		editSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				var ID = this.editIndex;
				var update = {};
				update["PreorderCategories." + ID] = response.output;
				for (var pID in this.oriItem.PreorderProducts){
					if (this.oriItem.PreorderProducts[pID].Category === this.oldCat){
						update["PreorderProducts." + pID + ".Category"] = response.output.Name;
					}
				}
				myFB.updateDoc(dbPath, update, docID, this, "Updating..." , "Updated!");
				this.cancel();
				this.cancel();
			}
		},
		//----------------------------- BACK -----------------------------//
		cancel(){
			this.viewing = false;
			this.adding = false;
			this.editing = false;
			this.sorting = false;
		},
		addElement(elementName, elementIndex){
			var temp;
			itemTemplate.forEach(r=>{
				if (r.Name == elementName){
					temp = r.children;
				}
			})
			var newElement = myInput.init(temp);
			if (this.adding){
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.addForm[elementName].push(newElement.output);
			}
			else{
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.editForm[elementName].push(newElement.output);
			}
		},
		//----------------------------- RD -----------------------------//
		viewStart(item){
			var editForm = myCopier.copy(item);
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.viewForm = response.output;
			this.viewing = true;
		},
		deleteItem(item, ID){
			if (confirm("Confirm deleting?")){
				if (item.Photo != "" && item.Photo != undefined){
					myFB.storage.ref(dbPath + "/" + ID).delete();
				}
				var update = {};
				update["PreorderCategories." + ID] = myFB.fieldVal.delete();
				update["PreorderCategoriesIndices"] = myFB.fieldVal.arrayRemove(ID);
				myFB.updateDoc(dbPath, update, docID, this, "Deleting..." , "Deleted!");
			};
		},
		//----------------------------- EXCEL -----------------------------//
		uploadExcel(e) {
			this.excelError = ""
			let fileList = e.target.files || e.dataTransfer.file
			Array.from(Array(fileList.length).keys()).map(x => {
				this.upload(fileList[x])
			})
		},
		upload(file){
			var reader = new FileReader();
			var json_object, field;
			var allowAdd = true;
			var response;
			reader.onload = (e => {
				var data = e.target.result;
				var workbook = XLSX.read(data,
				{
					type: "binary"
				});
				var allItems = {};
				var response;
				var allowAdd = true;
				var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
				workbook.SheetNames.forEach((sheetName,sheetIndex) => {
					var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
					json_object = XL_row_object;
					console.log(json_object)
					json_object.forEach( (obj, objectIndex) =>{
						var nameNow = obj.ID || uuid(Date() + Math.random(), uuid.DNS);
						try{
							if (allItems[nameNow] == undefined){
								response = myInput.checkMain(obj, checkFun);
								if (response.error){allowAdd = false;
									this.excelError += "Sheet " + (sheetIndex + 1).toString() + ", row " + (objectIndex + 2).toString() + " : "; 
									for (var it in response.errorMsg){
										if (response.errorMsg[it] != ''){
											this.excelError += it + "(" + response.errorMsg[it] + "), ";
										}
									}
									this.excelError += "\n";
								}
								else{
									allItems[nameNow] = response.output
								}
							}
						}
						catch(e){
							allowAdd = false;
							this.excelError += "Sheet " + (sheetIndex + 1).toString() + ", row " + (objectIndex + 2).toString() + " : Unknown error. Please refresh the page and try again.\n"; 
						}
					});
				});
				if (allowAdd){
					var update = {};
					var updateID = myCopier.copy(this.indices) || [];
					for (var item in allItems){
						update["PreorderCategories." + item] = allItems[item];
						if (!updateID.includes(item)){
							updateID.push(item);
						}
					}
					update["PreorderCategoriesIndices"] = updateID;
					console.log(update)
					myFB.updateDoc(dbPath, update, docID, this, "Creating...", "Created!"); 
				}
			});
			reader.onerror = function(ex) {
				console.log(ex);
			};
			reader.readAsBinaryString(file);
		},
		downloadExcel(includeData){
			const XLSX = require("xlsx");
			var field, field2;
			var allTitles = [[]];
			var wb = XLSX.utils.book_new();
			wb.Props = {
				Title: "Template",
				Subject: "Test",
				Author: "TeioRei",
				CreatedDate: new Date()
			};
			var defaultValues = [];
			var varIndex = 0;
			var nVariations = 0;
			wb.SheetNames.push("Test Sheet");
			
			allTitles[0].push("ID");
			allTitles[0] = [
			"ID",
			"Name",];
			
			if (includeData){
				this.indices.forEach(i=>{
					allTitles.push([
						this.items[i]["ID"],
						this.items[i]["Name"],
						this.items[i]["Category"],
						this.items[i]["Description"],
						this.items[i]["Measurement"],
						this.items[i]["Price"],
						this.items[i]["Available"],
						this.items[i]["Featured"],
						])
				})
			}

			wb.Sheets["Test Sheet"] = XLSX.utils.aoa_to_sheet(allTitles);
			var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
			var buf = new ArrayBuffer(wbout.length); 
			var view = new Uint8Array(buf);  
			for (var i=0; i<wbout.length; i++) {
				view[i] = wbout.charCodeAt(i) & 0xFF;
			} 
			saveAs(new Blob([buf],{type:"application/octet-stream"}), 'PreorderCategories-template.xlsx');
		},
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Manager/Categories.vue